import React from 'react';
import { ServiceCall } from 'modules/service-call/types';
import { Stack, Theme, Typography, useMediaQuery } from '@mui/material';
import { useIntl } from 'react-intl';
import { commonMessages } from 'utils/commonMessages';
import { LineItemProduct } from '../CreateNewServiceCall/ChooseLineItemStep/LineItemProduct';
import Divider from '@mui/material/Divider';
import dayjs, { tz } from 'dayjs';
import 'dayjs/plugin/timezone';
import { StatusChip } from 'components/StatusChip';

interface ServiceCallInformationProps {
  serviceCall: ServiceCall
}

export const ServiceCallInformation: React.FC<ServiceCallInformationProps> = ({ serviceCall }) => {
  const { formatMessage } = useIntl();
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const creationDate = dayjs.utc(serviceCall.createdOn).tz(tz.guess()).format('LLL');

  return (
    <Stack gap={2} position='sticky' top={100}>
      <Typography variant='h4' fontWeight={500}>{formatMessage({ id: 'ServiceCallInformation.Title', defaultMessage: 'Service call information' })}</Typography>
      {isMobile ? (
        <Stack gap={2}>
          <Stack>
            <Typography fontWeight={500}>{formatMessage({ id: 'ServiceCallInformation.CreatedOn', defaultMessage: 'Created on' })}</Typography>
            <Typography color='text.secondary'>{creationDate}</Typography>
          </Stack>

          <Stack>
            <Typography fontWeight={500}>{formatMessage(commonMessages.contractNumber)}</Typography>
            <Typography color='text.secondary'>{serviceCall.contractNumber}</Typography>
          </Stack>

          <Stack>
            <Typography fontWeight={500}>{formatMessage(commonMessages.clientNumber)}</Typography>
            <Typography color='text.secondary'>{serviceCall.clientNumber}</Typography>
          </Stack>

          <Stack>
            <Typography fontWeight={500}>{formatMessage({ id: 'ServiceCallInformation.Status', defaultMessage: 'Status' })}</Typography>
            <Stack width={100}>
              <StatusChip status={serviceCall.status} />
            </Stack>
          </Stack>
        </Stack>
      ) : (
        <Stack sx={{
          display: 'grid',
          gap: 2,
          gridTemplateColumns: 'repeat(2, 1fr)'
        }}>
          <Typography fontWeight={500}>{formatMessage({ id: 'ServiceCallInformation.CreatedOn', defaultMessage: 'Created on' })}</Typography>
          <Typography color='text.secondary'>{creationDate}</Typography>

          <Typography fontWeight={500}>{formatMessage(commonMessages.contractNumber)}</Typography>
          <Typography color='text.secondary'>{serviceCall.contractNumber}</Typography>

          <Typography fontWeight={500}>{formatMessage(commonMessages.clientNumber)}</Typography>
          <Typography color='text.secondary'>{serviceCall.clientNumber}</Typography>

          <Typography fontWeight={500}>{formatMessage({ id: 'ServiceCallInformation.Status', defaultMessage: 'Status' })}</Typography>
          <Stack width={100}>
            <StatusChip status={serviceCall.status} />
          </Stack>
        </Stack>
      )}
      <Divider />
      <LineItemProduct product={serviceCall.product} />
    </Stack>
  );
};